import SamplePoint, { SENSOR_NAME_BY_SENSOR_TAG_ID, SensorTagId } from 'types/models/samplePoint';
import { baseAlphabeticalSorter } from 'utils/sorters';

type MinimumSamplePointInfo = Pick<SamplePoint, 'sensorTags'>;
type SensorTypeGetter = (input: MinimumSamplePointInfo | SensorTagId) => string | undefined;

export const getPipeType: SensorTypeGetter = (input) => {
  const sensorTagId = typeof input === 'number' ? input : input.sensorTags.id;
  return sensorTagId === SensorTagId.GAS_FLOW_METER ? 'Gas Pipe' : 'Pipe';
};

export const getTroughType: SensorTypeGetter = (input) => {
  const sensorTagId = typeof input === 'number' ? input : input.sensorTags.id;
  return SENSOR_NAME_BY_SENSOR_TAG_ID[sensorTagId];
};

export const getSensorTypeSorter = (sensorTypeGetter: SensorTypeGetter) => (
  a: MinimumSamplePointInfo | SensorTagId,
  b: MinimumSamplePointInfo | SensorTagId
) => {
  const aLabel = sensorTypeGetter(a);
  const bLabel = sensorTypeGetter(b);

  return baseAlphabeticalSorter(aLabel || '', bLabel || '');
};